/** notebook 运行状态 */
import { i18n } from '@/i18n';
const { t } = i18n.global;
export enum EnumNotebookStatus {
  /** 未创建过notebook */
  default = -1,
  starting = 0,
  /** 运行中 */
  open = 1,
  /** 已停止 */
  closed = 2,
  error = 3
}

/** 计算类型 */
export enum EnumComputedType {
  NPU = 1,
  GPU = 2,
  CPU = 3
}

/** notebook 运行状态对应描述 */
export const notebookStatusMap: Map<EnumNotebookStatus, string> = new Map([
  [EnumNotebookStatus.open, 'aihub.notebook.opened'],
  [EnumNotebookStatus.closed, 'aihub.notebook.pause'],
  [EnumNotebookStatus.starting, 'aihub.notebook.starting'],
  [EnumNotebookStatus.default, 'aihub.notebook.notCreate'],
  [EnumNotebookStatus.error, 'aihub.notebook.runTimeError']
]);
